import { render, staticRenderFns } from "./HeaderAdmin.vue?vue&type=template&id=00179f0c&"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports